import { isImmutable } from 'immutable';

import { isObject } from '../isObject';

export function filter(instance, callback) {
  let result;

  if (isImmutable(instance)) {
    let index = 0;
    result = instance.filter((value, key) => callback(value, key, index++));
  } else if (Array.isArray(instance) || instance instanceof NodeList) {
    result = [];

    for (let index = 0; index < instance.length; index++) {
      callback(instance[index], index) && result.push(instance[index]);
    }
  } else if (isObject(instance)) {
    result = {};
    let index = 0;

    for (const key in instance) {
      if (instance.hasOwnProperty(key)) {
        callback(instance[key], key, index) && (result[key] = instance[key]);
        index += 1;
      }
    }
  }

  return result;
}
